/* eslint-disable */
import React, { FC } from 'react';

import style from './index.module.scss';
import NotFoundImg from '../../../assets/images/NF.png';

interface NotFoundProps {
  text?: string | any;
  withoutBG?: boolean | any;
}

// eslint-disable-next-line react/prop-types
const NotFound: FC<NotFoundProps> = ({ text, withoutBG }) => (
  <div className={`${style.notFound} ${withoutBG ? 'withoutBG' : ''}`}>
    <img src={NotFoundImg} alt="Ничего не найдено" className={style.image} />
    <h2 className={style.description}>{text || 'Мы ничего не нашли Проверьте запрос и попробуйте ещё раз'}</h2>
  </div>
);

export default NotFound;
